import {sha256} from 'js-sha256';

import StringTool from './string-tool';

export const OEStrEncoderResult = {
    ok:                         0,
    hashMismatch:               1,
    wrongType:                  2,
    unexpected:                 3,
};

OEStrEncoderResult.toString = (result) => {
    const map = [
        'succeeded',
        'hash mismatched',
        'wrong type',
        'unexpected'
    ];
    if(typeof(result) !== 'number' || result < 0 || result >= map.length)   return 'unkown';
    return map[result];
};

export const OEStrEncoderCompressionType = {
    none:                       0,
    urlDict:                    1
};

export const OEStrEncoderHashType = {
    none:                       0,
    sha256:                     1
};

export const OEStrEncoderCodeType = {
    urlParameter:               0,
    urlParameterComp:           1,
    COUNT:                      2
};

export const OEStrEncoderCodeDescs = [
    {
        prefix: 'URL_PARAM',
        key: 'prAkisWIchU1R&C&=l-ip0o@h+&rEtR_',
        hash: {
            type: OEStrEncoderHashType.sha256,
            salt: '$w9M+sWId0+l8lsw',
            length: 32
        },
        allowEmpty: true,
        compression: OEStrEncoderCompressionType.none,
    },
    {
        prefix: 'UC',
        key: 'prAkisWIchU1R&C&=l-ip0o@h+&rEtR_',
        hash: {
            type: OEStrEncoderHashType.sha256,
            salt: '$w9M+sWId0+l8lsw',
            length: 8
        },
        allowEmpty: true,
        compression: OEStrEncoderCompressionType.urlDict,
    }
];

export class OEStrEncoderCompressor   {

    constructor()   {
        // do not change the order!
        const words = [
            'autoplay',
            'noFullscreen',
            'noTitleBar',
            'noStartView',
            'showMainMenu',
            'target',
            'showFullscreenBtn',
            'status',
            'customer',
            'flags',
            'labelsEnabled',
            'labelsLatin',
            'license',
            'linkRef',              // in front of link is relevant
            'link',
            'uiLinkRef',            // in front of uiLink is relevant
            'uiLink',
            'mcVisible',
            'category',
            'item',
            'subItem',
            'resourceId',
            'progress',
            '=true',
            '=false',
            '=TRUE',
            '=FALSE',
            'noContextMenu',
            'showTitleBar'
        ];

        this._urlDictCompressionMap = words.map((w, i) => { return {key: w, value: StringTool.stringFromUTF8Array([i + 1, 0])}; });
        this._urlDictDecompressionMap = this._urlDictCompressionMap.map(p => { return {key: p.value, value: p.key}; });
    }

    get urlDictCompressionMap() {
        return this._urlDictCompressionMap;
    }

    get urlDictDecompressionMap() {
        return this._urlDictDecompressionMap;
    }

    compress(str, type)   {
        if(type === OEStrEncoderCompressionType.none)   return str;
        if(type === OEStrEncoderCompressionType.urlDict)    {
            this._urlDictCompressionMap.forEach(p => {
                str = str.replaceAll(p.key, p.value);
            });
            return str;
        }
        return str;
    }

    decompress(str, type)   {
        if(type === OEStrEncoderCompressionType.none)   return str;
        if(type === OEStrEncoderCompressionType.urlDict)    {
            this._urlDictDecompressionMap.forEach(p => {
                str = str.replaceAll(p.key, p.value);
            });
            return str;
        }
        return str;
    }
};

const OEStrEncoder = {
    
    cmpArrays(a, b) {
        if(a.length !== b.length)   return false;
        for(let i = 0; i < a.length; ++i)   {
            if(a[i] !== b[i])    return false;
        }
        return true;
    },

    encryptXOR(buffer, key) {
        if(!buffer.length || !key || !key.length)   return;

        for(let i = 0; i < buffer.length; ++i)  {
            buffer[i] = buffer[i] ^ key[i % key.length];
        }
    },

    hash(str, desc) {
        if(desc.type === OEStrEncoderHashType.sha256)   {
            let str_ = str;
            if(desc.salt)   str_ = str_ + desc.salt;
            let buffer = StringTool.stringToUTF8Array(str_);
            let hash = sha256.array(buffer);
            if(typeof(desc.length) !== 'number' || desc.length <= 0 || desc.length == hash.length)	return hash;
            let hash_ = new Array(desc.length);
            for(let i = 0; i < desc.length; ++i)    hash_[i] = 0;
            hash.forEach((v, i) => {
                hash_[i % desc.length] = hash_[i % desc.length] ^ v;
            });
            return hash_;
        }
        return [];
    },

    hashByteArray(data, desc) {
        if(desc.type === OEStrEncoderHashType.sha256)   {
            let buffer = data;
            if(desc.salt)   {
                let saltBuffer = StringTool.stringToUTF8Array(desc.salt);
                buffer = buffer.concat(saltBuffer);
            }
            let hash = sha256.array(buffer);
            if(typeof(desc.length) !== 'number' || desc.length <= 0 || desc.length == hash.length)	return hash;
            let hash_ = new Array(desc.length);
            for(let i = 0; i < desc.length; ++i)    hash_[i] = 0;
            hash.forEach((v, i) => {
                hash_[i % desc.length] = hash_[i % desc.length] ^ v;
            });
            return hash_;
        }
        return [];
    },

    decrypt(src, key, hashDesc)   {
        if(typeof(src) !== 'string')    throw OEStrEncoderResult.unexpected;

        const hasHash = hashDesc && hashDesc.type != OEStrEncoderHashType.none;
        const hashSize = hashDesc && typeof(hashDesc.length) === 'number' && hashDesc.length > 0 ? hashDesc.length : 32;

        if(!src.length && !hasHash) return '';

        try {
            var buffer = StringTool.base64ToBytes(StringTool.base64fromURL(src));
        } catch(exception) {
            throw OEStrEncoderResult.unexpected;
        }

        if(hasHash && buffer.length < hashSize)    throw OEStrEncoderResult.hashMismatch;

        if(key) {
            let keyBuffer = StringTool.stringToUTF8Array(key);
            this.encryptXOR(buffer, keyBuffer);
        }

        if(!hasHash)    return StringTool.stringFromUTF8Array(src);

        let hash = buffer.slice(0, hashSize);
        buffer = buffer.slice(hashSize);
        let strDst = StringTool.stringFromUTF8Array(buffer);

        try {
            var hash_ = this.hashByteArray(buffer, hashDesc);
        } catch(exception) {
            throw OEStrEncoderResult.unexpected;
        }

        if(!this.cmpArrays(hash, hash_))    throw OEStrEncoderResult.hashMismatch;

        return strDst;
    },

    decode(src, descOrType)  {
        let desc = descOrType;
        if(typeof(desc) === 'number')   {
            if(desc < 0 || desc >= OEStrEncoderCodeType.COUNT)   throw OEStrEncoderResult.unexpected;
            desc = OEStrEncoderCodeDescs[desc];
        }

        if(typeof(desc) !== 'object' || desc === null)  throw OEStrEncoderResult.unexpected;

        if(desc.allowEmpty && !src.length)  return '';

        let str = this.decrypt(src, desc.key, desc.hash);

        if(!desc.prefix)    return str;

        let prefix = str.slice(0, desc.prefix.length);
        if(prefix !== desc.prefix)  throw OEStrEncoderResult.wrongType;

        str = str.slice(desc.prefix.length);
        return (new OEStrEncoderCompressor()).decompress(str, desc.compression);
    },

    decodeURL(url)  {
        try {
            return this.decode(url, OEStrEncoderCodeType.urlParameter);
        } catch(res) {
            try {
                return this.decode(url, OEStrEncoderCodeType.urlParameterComp);
            } catch(res) {
                throw res;
            }
        }
    }
};

export default OEStrEncoder;

